import React, { useState } from 'react';
import { getSettings } from '../../util/getSettings';

const CheckBox = ({ id, name, label, checked, ...props }) => (
  <div className="checkbox-input-container">
    <input type="checkbox" id={id} name={name} checked={checked} {...props} />
    <label htmlFor={id}>{label}</label>
  </div>
);

const MpcFilter = ({ currentMpcFilter, onChange }) => {
  const labels = getSettings(['century', 'labels'], true);
  const [mpcOnly, setMpcOnly] = useState(currentMpcFilter);
  const onMpcOnlyChange = () => {};
  const onMpcOnlyClick = () => {
    const newVal = !mpcOnly;
    setMpcOnly(newVal);
    onChange(newVal);
  };
  return (
    <fieldset className="mpc-filter-container">
      <legend className="filter-title">{labels.mpcTitleLabel}</legend>
      <div>
        <CheckBox 
          label={labels.mpcControlLabel} 
          id="mpc-only"
          checked={mpcOnly}
          onChange={onMpcOnlyChange}
          onClick={onMpcOnlyClick} />
      </div>
    </fieldset>
  );
};

export default MpcFilter;